// vim: set ts=2 sts=2 sw=2 et:
//
// This file is part of OpenLifter, simple Powerlifting meet software.
// Copyright (C) 2019 The OpenPowerlifting Project.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.

import { Entry, Equipment, Event, Sex } from "../../types/dataTypes";

export type RegistrationFilters = {
  sexes: ReadonlyArray<Sex>;
  equipment: ReadonlyArray<Equipment>;
  divisions: ReadonlyArray<string>;
  events: ReadonlyArray<Event>;
};

export const emptyRegistrationFilters = (): RegistrationFilters => ({
  sexes: [],
  equipment: [],
  divisions: [],
  events: [],
});

const matchesSex = (entry: Entry, sexes: ReadonlyArray<Sex>): boolean => {
  return sexes.length === 0 || sexes.includes(entry.sex);
};

const matchesEquipment = (entry: Entry, equipment: ReadonlyArray<Equipment>): boolean => {
  return equipment.length === 0 || equipment.includes(entry.equipment);
};

const matchesDivisions = (entry: Entry, divisions: ReadonlyArray<string>): boolean => {
  return divisions.length === 0 || entry.divisions.some((d) => divisions.includes(d));
};

const matchesEvents = (entry: Entry, events: ReadonlyArray<Event>): boolean => {
  return events.length === 0 || entry.events.some((e) => events.includes(e));
};

export const filterEntries = (entries: ReadonlyArray<Entry>, filters: RegistrationFilters): Entry[] => {
  return entries.filter(
    (entry) =>
      matchesSex(entry, filters.sexes) &&
      matchesEquipment(entry, filters.equipment) &&
      matchesDivisions(entry, filters.divisions) &&
      matchesEvents(entry, filters.events),
  );
};
